import { axiosService } from "./axiosService";

const userEventApi = {
    getAll(params) {
        const url = '/user-event';
        return axiosService.get(url, { params })
    },
    checkInfo(body) {
        const url = '/user-event/check';
        return axiosService.post(url, body)
    },
    create(body) {
        const url = '/user-event';
        return axiosService.post(url, body)
    },
    update(id, body) {
        const url = `/user-event/${id}`;
        return axiosService.put(url, body)
    },
    delete(id) {
        const url = `/user-event/${id}`;
        return axiosService.delete(url)
    },
    resetAllQr() {
        const url = '/user-event/reset-all-qr';
        return axiosService.post(url);
    }
}

export default userEventApi;